import log from '../../../../services/logger/log';
import uamClientService from '../../../../services/uam/uamClientService';
import {setIsAutomaticFWInstallationActive} from '../../../../state/slice/iotDevices';
import {dispatch} from '../../../../state/store';

const getAutomaticInstallationConfig = async (dusn) => {
    try {
        if (!dusn) return;

        const response = await uamClientService.getSilentFwuConfig(dusn);

        dispatch(setIsAutomaticFWInstallationActive(dusn, response));
    } catch (e) {
        log.error('Error fetching automatic installation config:', e);
    }
};

const updateAutomaticInstallationConfig = async (dusn, isActive) => {
    try {
        await uamClientService.postSilentFwuConfig(dusn, {isSilentUpdateAllowed: isActive});
    } catch (e) {
        log.error('Error disabling automatic installation config:', e);
        throw e;
    }
};

export default {
    getAutomaticInstallationConfig,
    updateAutomaticInstallationConfig,
};
